import { render, staticRenderFns } from "./UserShortcutList.vue?vue&type=template&id=146d90b0"
import script from "./UserShortcutList.vue?vue&type=script&lang=js"
export * from "./UserShortcutList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports